'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { ArrowRight, Play, Flame, Sparkles, Store, TrendingUp } from 'lucide-react';
import { useState } from 'react';
const audienceLanes = [{
  icon: Sparkles,
  title: 'For people who want great product experiences',
  description: 'Discover, try, enjoy, and come back to products that genuinely fit your life.',
  accent: 'bg-primary-50 text-primary-700 ring-primary-100'
}, {
  icon: Store,
  title: 'For retailers, buyers, and hosts',
  description: 'Create real-world discovery moments that bring people in and keep them engaged.',
  accent: 'bg-blue-50 text-blue-700 ring-blue-100'
}, {
  icon: TrendingUp,
  title: 'For brands and makers',
  description: 'Launch ideas that turn first discovery into repeat purchase and momentum.',
  accent: 'bg-amber-50 text-amber-700 ring-amber-100'
}];
export function HeroSectionV3() {
  const $ = _c(12);
  const [showVideo, setShowVideo] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="absolute inset-0 bg-gradient-to-br from-orange-50/70 via-white to-rose-50/50" />;
    t1 = <div className="absolute -top-24 -left-24 h-80 w-80 rounded-full bg-primary-100/35 blur-3xl" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Flame className="h-4 w-4 text-primary-500" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="mb-8 flex items-center justify-center gap-2">{t2}<p className="text-sm font-medium text-gray-600">Early Preview -{" "}<Link href="/early-preview" className="cursor-pointer text-primary-600 underline hover:no-underline">Learn more</Link></p></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <p className="mb-4 text-sm font-semibold uppercase tracking-[0.2em] text-primary-600">For people who want great product experiences. For the people and businesses helping them happen.</p>;
    t5 = <h1 className="mb-6 text-4xl font-extrabold leading-[1.15] text-gray-900 sm:text-5xl lg:text-6xl">Where discovery, trial, and enjoyment meet.</h1>;
    t6 = <p className="mb-4 max-w-2xl text-xl text-gray-600 lg:text-2xl">Sizzle helps more people find more things they genuinely enjoy, while helping the brands, retailers, buyers, hosts, and other businesses behind those experiences make more of them happen.</p>;
    t7 = <p className="mb-8 max-w-2xl text-lg text-gray-500 lg:text-xl">From first discovery to repeat purchase, Sizzle helps great products become part of people's routines.</p>;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
  } else {
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="mb-8 flex flex-col gap-4 sm:flex-row"><Link href="/for-me" className="inline-flex items-center justify-center gap-2 rounded-full bg-primary-600 px-8 py-4 text-lg font-bold text-white shadow-lg shadow-primary-200 transition-all hover:bg-primary-700 cursor-pointer">Explore What's On<ArrowRight className="h-5 w-5" /></Link><Link href="#home-v3-role-chooser" className="inline-flex items-center justify-center gap-2 rounded-full border border-gray-200 bg-white px-8 py-4 text-lg font-semibold text-gray-700 shadow-sm transition-all hover:border-gray-300 hover:bg-gray-50 cursor-pointer">Choose your path</Link></div>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div>{t4}{t5}{t6}{t7}{t8}<div className="grid grid-cols-1 gap-3 sm:grid-cols-3">{audienceLanes.map(_temp)}</div></div>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== showVideo) {
    t10 = <section className="relative overflow-hidden bg-white pb-16">{t0}{t1}<div className="container relative z-10 mx-auto px-4 py-4 sm:px-6 lg:px-8 lg:py-4">{t3}<div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2 lg:gap-16">{t9}<div className="relative aspect-[4/3] overflow-hidden rounded-3xl bg-gray-100 shadow-2xl ring-1 ring-black/5">{showVideo ? <div className="absolute inset-0 flex items-center justify-center bg-black"><p className="text-lg text-white">Video player placeholder</p></div> : <><img src="https://images.unsplash.com/photo-1604719312566-8912e9227c6a?w=900&h=675&fit=crop" alt="Packaged consumer products displayed in a retail environment" className="h-full w-full object-cover" onError={_temp2} /><button onClick={() => setShowVideo(true)} className="group/play absolute inset-0 flex cursor-pointer items-center justify-center" aria-label="Play video"><div className="flex h-20 w-20 items-center justify-center rounded-full bg-white shadow-xl ring-4 ring-primary-100 transition-transform group-hover/play:scale-110"><Play className="ml-1 h-8 w-8 text-primary-600" /></div></button></>}</div></div></div></section>;
    $[10] = showVideo;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  return t10;
}
function _temp2(e) {
  (e.target as HTMLImageElement).style.display = "none";
  (e.target as HTMLImageElement).parentElement.classList.add("bg-gradient-to-br", "from-orange-200", "via-primary-100", "to-amber-100");
}
function _temp(t0) {
  const {
    icon: Icon,
    title,
    description,
    accent
  } = t0;
  return <div key={title} className={`rounded-2xl p-4 ring-1 ${accent} shadow-sm backdrop-blur-sm`}><div className="mb-3 inline-flex h-10 w-10 items-center justify-center rounded-xl bg-white/80 shadow-sm"><Icon className="h-5 w-5" /></div><h3 className="mb-1 text-sm font-bold">{title}</h3><p className="text-sm leading-relaxed text-gray-600">{description}</p></div>;
}